import { useEffect, useRef } from "react";

const COIN_SRC = "/fronk/props/badge-pepe-coin.webp";
const MAX_COINS = 14;
const MIN_DIST = 46;
const MIN_MS = 70;

export const CoinTrail = () => {
  const containerRef = useRef(null);
  const lastRef = useRef({ x: -100, y: -100, t: 0 });

  useEffect(() => {
    const fine = window.matchMedia("(pointer: fine)").matches;
    const reduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (!fine || reduced) return undefined;

    const container = containerRef.current;
    if (!container) return undefined;

    const onMove = (e) => {
      const now = performance.now();
      const { x, y, t } = lastRef.current;
      const dist = Math.hypot(e.clientX - x, e.clientY - y);
      if (now - t < MIN_MS || dist < MIN_DIST) return;
      lastRef.current = { x: e.clientX, y: e.clientY, t: now };
      if (container.childElementCount >= MAX_COINS) return;

      const coin = document.createElement("img");
      coin.src = COIN_SRC;
      coin.alt = "";
      coin.className = "fronk-coin-particle";
      const size = 14 + Math.random() * 10;
      coin.style.width = `${size}px`;
      coin.style.left = `${e.clientX + (Math.random() * 18 - 9)}px`;
      coin.style.top = `${e.clientY + (Math.random() * 18 - 9)}px`;
      coin.style.setProperty("--coin-rot", `${Math.random() * 70 - 35}deg`);
      coin.style.setProperty("--coin-drift", `${Math.random() * 26 - 13}px`);
      container.appendChild(coin);
      window.setTimeout(() => coin.remove(), 950);
    };

    window.addEventListener("pointermove", onMove, { passive: true });
    return () => window.removeEventListener("pointermove", onMove);
  }, []);

  return (
    <div
      ref={containerRef}
      className="pointer-events-none fixed inset-0 z-[70] overflow-hidden"
      aria-hidden="true"
      data-testid="coin-trail-layer"
    />
  );
};
